import {
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownTrigger,
} from '@nextui-org/react';
import { ChevronDown } from 'lucide-react';
import React from 'react';

type DropdownOption = {
  key: string;
  label: string;
  onClick: () => void;
};

type DropdownButtonProps = {
  label: string;
  options: DropdownOption[];
  isDisabled?: boolean;
};

export const ZDropdownButton: React.FC<DropdownButtonProps> = ({
  label,
  options,
  isDisabled = false,
}) => {
  return (
    <Dropdown placement="bottom-end" isDisabled={isDisabled}>
      <DropdownTrigger>
        <Button
          className="bg-primary text-white px-3 py-1 h-auto rounded-none border-r border-white/30 [&:disabled]:opacity-100 [&:disabled]:bg-primary [&:disabled]:text-white"
        >
          {label}
          <ChevronDown className="size-4 text-white" />
        </Button>
      </DropdownTrigger>
      <DropdownMenu aria-label={`${label} options`}>
        {options.map((option) => (
          <DropdownItem key={option.key} onClick={option.onClick}>
            {option.label}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  );
};
